<template>
  <section>
    <div class="form-content">
      <div class="tip" style="margin:0 0 0 20px">* 维修申请提交资料</div>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="送修单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送修人">
            <user-info :userData='userData'></user-info>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="维修车辆">
        <el-select size="small" class="project-list-select" :disabled="true" v-model="wxform.carId" filterable placeholder="请选择(可搜索车牌号)">
          <el-option v-for="item in carList" :key="item.id" :label="item.xh+' - '+item.plateNo+' - '+item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="维修单位">
            <el-input size="small" :disabled="true" v-model="wxform.wxdw"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计费用(元)">
            <el-input size="small" :disabled="true" type="number" placeholder="预计维修费用(元)" v-model="wxform.price"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="送修日期">
            <el-date-picker :disabled="true" size="small" value-format="yyyy-MM-dd" v-model="wxform.startTime" type="date"
              placeholder="送修日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="完成日期">
            <el-date-picker :disabled="true" size="small" value-format="yyyy-MM-dd" v-model="wxform.endTime" type="date"
              placeholder="完成日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="报修内容">
        <el-input type="textarea" :disabled="true" placeholder="申请修理的内容" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="wxform.reason"></el-input>
      </el-form-item>


      <div class="tip" style="margin:0 0 0 20px">* 车辆维修实际情况</div>
      <el-form-item label="报修前">
        <el-input type="textarea" placeholder="维修前车辆情况" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="form.wxq"></el-input>
      </el-form-item>
      <el-form-item label="报修后">
        <el-input type="textarea" placeholder="维修后车辆情况" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="form.wxh"></el-input>
      </el-form-item>


    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', 'useApplyType', 'carType', 'wxform'],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    components: {
      UserInfo,
    },
    data() {
      return {
        form: {},
        carList: [],
        depId: "",
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      this.getCarLists()
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // 获取所有车辆
      getCarLists() {
        ajax.get('/car/list', {
          depId: this.depId
        }, (res) => {
          this.loading = false
          this.carList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      },
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/accept.vue